import React from "react";
import { Accordion, Col, Container, Row } from "react-bootstrap";
import BreadCrumb from "@/src/components/Shared/BreadCrumbs";

import { FormattedMessage, useIntl } from "react-intl";
import styles from "@/styles/contact.module.scss";
import server from "@/src/api/server";
import { checkRedirect } from "@/src/components/helpers/functions";
import Seo from "@/src/components/Shared/Next-seo";

const FaqsPage = ({ faqsData, initData, error, seoData }) => {
  const { locale, formatMessage } = useIntl();
  error && console.log(JSON.parse(error));

  const faqs = faqsData?.initData?.items;
  const middleIndex = Math.ceil(faqs?.length / 2);
  const leftColumnFAQs = faqs?.slice(0, middleIndex);
  const rightColumnFAQs = faqs?.slice(middleIndex);
  return (
    <>
      {seoData?.title?.[locale] && (
        <Seo
          title={seoData?.title?.[locale]}
          description={seoData?.description?.[locale]}
          keywords={seoData?.keywords?.[locale]}
        />
      )}
      <div className={`contact-page ${styles.contact}`}>
        <BreadCrumb
          heading={formatMessage({ id: "faq" })}
          description={`${formatMessage({
            id: "main",
          })} / ${formatMessage({
            id: "faq",
          })}`}
          background={faqsData?.breadCurmbImage}
        />

        {/* <Row>
                    <h2 className="contact-header unique-bold">
                        <FormattedMessage id="faq" />
                    </h2>
                </Row> */}
        <Container>
          {/* Left Column */}
          <Accordion>
            <Row className="gy-4">
              <Col md={6}>
                {leftColumnFAQs.map((faq, index) => (
                  <Accordion.Item
                    eventKey={`left-${index}`}
                    key={`left-${index}`}
                  >
                    <Accordion.Header
                      style={{
                        width: "100%",
                        justifyContent: "space-between",
                      }}
                    >
                      {faq?.title?.[locale]}
                    </Accordion.Header>
                    <Accordion.Body>
                      {faq?.description?.[locale]}
                    </Accordion.Body>
                  </Accordion.Item>
                ))}
              </Col>

              {/* Right Column */}
              <Col md={6}>
                {rightColumnFAQs.map((faq, index) => (
                  <Accordion.Item
                    eventKey={`right-${index}`}
                    key={`right-${index}`}
                  >
                    <Accordion.Header>{faq?.title?.[locale]}</Accordion.Header>
                    <Accordion.Body>
                      {faq?.description?.[locale]}
                    </Accordion.Body>
                  </Accordion.Item>
                ))}
              </Col>
            </Row>
          </Accordion>
        </Container>
        {/* <div className="contact-page-top wrapper"> */}
        {/* <SectionHead
                        subtitle={<FormattedMessage id="contact_through" />}
                        title={<FormattedMessage id="contact_long" />}
                        /> */}
        {/* <Row>
                        <div className="contact-row-wrapper p-0">
                            <Row className="contact-row">
                                <Col
                                    xs="12"
                                    md="6"
                                    className="align-self-center"
                                >
                                    <Form
                                        formTitle={
                                            <FormattedMessage id="service?.title?.[locale]" />
                                        }
                                        formSubtitle={
                                            <FormattedMessage id="service_ask" />
                                        }
                                    />
                                </Col>

                                <Col xs="12" md="6">
                                    <div
                                        className="contact-page-map"
                                        data-aos="fade-up"
                                        data-aos-duration="300"
                                        data-aos-delay="400"
                                        dangerouslySetInnerHTML={{
                                            __html:
                                                initData?.siteInfo?.mapframe ??
                                                "",
                                        }}
                                    ></div>
                                </Col>
                            </Row>
                        </div>
                    </Row> */}
        {/* </div> */}
        {/* <ContactNumbers initData={initData} /> */}
        {/* <Row className="contact-info">
                    <ContactsElements initData={initData} locale={locale} />
                </Row> */}
      </div>
    </>
  );
};

export async function getServerSideProps(ctx) {
  const redirect = await checkRedirect(ctx.resolvedUrl, ctx.req);
  if (redirect) return { redirect };

  const [homeResponse, faqsResponse, seoPageResponse] = await Promise.all([
    server.get("/pages/home"),
    server.get("/pages/faqs"),
    server.get("/pages/seo-data"),
  ]);

  const sectionData = (r) => r?.data?.data?.page?.sections || [];
  const homeData = (section) =>
    sectionData(homeResponse)?.filter((e) => e?.slug == section)?.[0] || [];
  const seoData = sectionData(faqsResponse)?.find(
    (section) => section?.slug === "seo"
  );
  return {
    props: {
      faqsData: {
        breadCurmbImage: homeData("intro")?.items[0]?.backgroundImage,
        initData: faqsResponse?.data?.data?.page?.sections?.find(
          (e) => e?.slug === "faqs"
        ),
      },
      seoData,
    },
  };
}

export default FaqsPage;
